import * as actionsTypes from './actions';

const initialState = {
    isLoading: false,
    allAirlinkDevices: {},
    singleSafelinkDevice: {},
    deviceHistory: []
}

export default function (state = { ...initialState }, action) {
    switch (action.type) {

        case actionsTypes.GET_ALL_AIRLINK_DEVIECS_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_ALL_AIRLINK_DEVIECS_SUCCESS:
            return { ...state, isLoading: false, allAirlinkDevices: action.payload || {} }

        case actionsTypes.GET_ALL_AIRLINK_DEVIECS_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_SINGLE_AIRLINK_DEVIECS_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_SINGLE_AIRLINK_DEVIECS_SUCCESS:
            return { ...state, isLoading: false, singleSafelinkDevice: action.payload || {} }

        case actionsTypes.GET_SINGLE_AIRLINK_DEVIECS_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_AIRLINK_DEVICE_HISTORY_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_AIRLINK_DEVICE_HISTORY_SUCCESS:
            return { ...state, isLoading: false, deviceHistory: action.payload || [] }

        case actionsTypes.GET_AIRLINK_DEVICE_HISTORY_FAILED:
            return { ...state, isLoading: false }

        default:
            return state
    }
}